<script setup lang="ts">
import {useI18n} from "vue-i18n";

const {t} = useI18n(); // Import the translation function
import {ref} from "vue";

interface FaqItem {
  question: string;
  answer: string;
  open: boolean;
}

const faqs = ref<FaqItem[]>([
  {question: t('ThingsToKnow.faqs[0].question'), answer: t('ThingsToKnow.faqs[0].answer') , open: false},
  {question: t('ThingsToKnow.faqs[1].question'), answer: t('ThingsToKnow.faqs[1].answer'), open: false},
  {question: t('ThingsToKnow.faqs[2].question'), answer: t('ThingsToKnow.faqs[2].answer'), open: false},
  {question: t('ThingsToKnow.faqs[3].question'), answer: t('ThingsToKnow.faqs[3].answer'), open: false},
  {question: t('ThingsToKnow.faqs[4].question'), answer: t('ThingsToKnow.faqs[4].answer'), open:false},
  {question: t('ThingsToKnow.faqs[5].question'), answer: t('ThingsToKnow.faqs[5].answer'), open:false},
  {question: t('ThingsToKnow.faqs[6].question'), answer: t('ThingsToKnow.faqs[6].answer'), open:false}


]);

</script>
<template>
  <div class="bg-background-light mt-20">
    <div class=" flex justify-between container py-12 flex-col sm:flex-row" id="things-to">
      <div class="min-w-1/4">
        <div class="faq-title mb-6 responsive-title-4 font-bold">{{ t('thingsToKnow') }}</div>
      </div>
      <div class="faq-content w-full sm:w-2/3">
        <div v-for="(item, index) in faqs" :key="index">
          <el-collapse accordion>
            <el-collapse-item :title="item.question" name="1">
              <div class="my-2.5">
                {{ item.answer }}
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>

:deep(.el-collapse-item .el-collapse-item__header) {
  font-size: 1.25rem;
  background: #f8f8f8;
}

.faq-content div:not(:first-child) {
  padding-top: .875rem;
}

:deep(.el-collapse-item__wrap) {
  border: none;
}

:deep(.el-collapse-item__header) {
  @apply faq-question font-semibold flex justify-between text-xl transition-opacity hover:opacity-60;
}

:deep(.el-collapse-item__content) {
  @apply faq-answer text-base pb-0;
}

:deep(.el-collapse-item__wrap) {
  background-color: unset;
}
.el-collapse {
  border: none;
  --el-collapse-header-height: unset;
}


.faq-question {
  width: 100%;
  text-align: left;
  border: none;
  cursor: pointer;
  outline: none;
}

.faq-answer {
  border-top: none;
}

:deep(.faq-content div:not(:last-child)) {
  border-bottom: solid 1px rgba(183, 182, 190, 0.5);

}

.faq-content div:has(.el-collapse) {
  padding-bottom: .875rem !important;
}

:deep(.el-collapse-item__arrow) {
  transform: rotate(90deg);
}

:deep(.el-collapse-item__arrow.is-active) {
  transform: rotate(270deg);
}


</style>